// Small UI utilities: selection, HTML escaping, modals, notifications, formats.
import { busyWhile, esc, on, safeColor } from '@gruvetto/browser';
import { t } from '../i18n/index.js';
import { icon } from './brand.js';
export const $ = (sel: string, root: ParentNode = document): any => root.querySelector(sel);
export const $$ = (sel: string, root: ParentNode = document): any[] => [...root.querySelectorAll(sel)];

export { busyWhile, esc, safeColor, on };

/** Status icon of each toast kind (brand.ts): the kind shows on the icon only, the card stays neutral. */
export const TOAST_ICONS = { good: 'check', bad: 'alert', warn: 'alert', info: 'info' };

/** Short feedback in the corner of the screen: a status icon and a sentence (docs/DESIGN.md). */
export function toast(text, kind: 'good' | 'bad' | 'warn' | 'info' = 'info', ms = 3500) {
  let box = document.getElementById('toasts-app');
  if (!box) { box = document.createElement('div'); box.id = 'toasts-app'; document.body.appendChild(box); }
  const el = document.createElement('div');
  el.className = 'toast-app ' + kind;
  el.setAttribute('role', kind === 'bad' ? 'alert' : 'status');
  const ico = document.createElement('span');
  ico.className = 't-ico'; ico.innerHTML = icon(TOAST_ICONS[kind] || 'info', 14);
  const msg = document.createElement('span');
  msg.textContent = text;
  el.append(ico, msg);
  box.appendChild(el);
  setTimeout(() => el.remove(), ms);
}

/** Opens a modal; returns { el, close }. `onClose` is called when it closes. */
export function modal(html, { wide = false, onClose, dismissable = true }: any = {}) {
  const ov = document.createElement('div');
  ov.className = 'overlay';
  ov.innerHTML = `<div class="modal ${wide ? 'wide' : ''}">${html}</div>`;
  document.body.appendChild(ov);
  const close = () => { ov.remove(); document.removeEventListener('keydown', key); onClose?.(); };
  // the Escape that closes a modal must not also reach the game, which would reopen its pause menu
  const key = e => { if (e.key === 'Escape' && dismissable) { e.stopPropagation(); close(); } };
  document.addEventListener('keydown', key);
  if (dismissable) ov.addEventListener('mousedown', e => { if (e.target === ov) close(); });
  ov.querySelectorAll('[data-close]').forEach(b => b.addEventListener('click', close));
  return { el: ov.firstElementChild as any, close };
}

export function confirmBox(text, okLabel = t.common.confirm, danger = false) {
  return new Promise(res => {
    const m = modal(`<h2>${esc(text)}</h2><div class="actions"><button data-close>${esc(t.common.cancel)}</button><button class="${danger ? 'danger' : 'primary'}" data-ok>${esc(okLabel)}</button></div>`, { onClose: () => res(false) });
    m.el.querySelector('[data-ok]').onclick = () => { res(true); m.close(); };
  });
}

// ---------- Formats ----------
// Formats depend on the player's locale (language, time zone, clock): see i18n/index.ts.
export { fmtDur, fmtClock, fmtKm, fmtDate, fmtDateTime } from '../i18n/index.js';
